import React from "react";
import { UI_ModuleCardProps } from "../../interfaces/props/UI_ModuleCardProps";

import classes from "./style/UI_ITOModuleCard.module.css";

export function UI_ModuleCard(props: UI_ModuleCardProps) {
  const { title, children, style } = props;

  return (
    <div style={style} className={classes.card}>
      {title && (
        <div className={classes.card__header}>
          <span className={classes.card__title}>{title}</span>
        </div>
      )}
      <div className={classes.card__content}>{children}</div>
    </div>
  );
}
